import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { getStaffTableColumns } from '../utils/staffTableColumn';
import { StaffProps } from '../types';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const StaffTable = ({
  isLoading,
  staffData,
  handleEditClick
}: {
  isLoading: boolean;
  staffData: StaffProps[];
  handleEditClick: (Id: string) => void;
}) => {
  const staffColumns = getStaffTableColumns(handleEditClick);
  return (
    <PageWrapper>
      <DataGrid
        rowHeight={50}
        rows={staffData}
        columns={staffColumns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{
          toolbar: CustomDataGridToolbar
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default StaffTable;
